import { financesInstance } from '../../axios/axios.js';

const util = {
  getFormattedDate(timestamp) {
    let date = new Date(timestamp).toISOString();
    let rawDate = date.split('T')[0].split('-');
    date = `${rawDate[2]}.${rawDate[1]}.${rawDate[0]}.`;

    return date;
  }
};

export default {
  state: {
    transactions: {
      isLoading: false,
      count: 0,
      data: []
    },
    expenses: {
      isLoading: false,
      count: 0,
      data: []
    },
    invoices: {
      isLoading: false,
      count: 0,
      data: []
    },
    virtualMembers: {
      isLoading: false,
      count: 0,
      data: []
    },
    accountDetails: {
      pib: null,
      mb: null,
      bank: null,
      account: null,
      positive_balance: null,
      negative_balance: null,
      balance: null
    }
  },
  mutations: {
    setTableData(state, payload) {
      state[payload.tableName].data = payload.data;
    },
    setTableCount(state, payload) {
      state[payload.tableName].count = payload.count;
    },
    setTableIsLoading(state, payload) {
      state[payload.tableName].isLoading = payload.isLoading;
    },
    setAccount(state, payload) {
      state.accountDetails = payload;
    },
    updateAccount(state, payload) {
      state.accountDetails.mb = payload.mb;
      state.accountDetails.bank = payload.bank;
      state.accountDetails.pib = payload.pib;
      state.accountDetails.account = payload.account;
    },
    setVirtualMembersList(state, vms) {
      state.virtualMembers.data = vms;
    }
  },
  actions: {
    async getTableData(context, data) {
      const communityId = data.communityId;
      const tableName = data.tableName;

      context.commit('setTableIsLoading', {
        tableName,
        isLoading: true
      });
      await financesInstance
        .get(`communities/${communityId}/${tableName}`)
        .then(res => {
          const data = res.data[tableName];
          for (let item of data) {
            if (tableName == 'transactions') {
              item.full_name = item.full_name
                ? item.full_name
                : 'Zajednica stanara';
              item.dataType = 'transaction';
              if (item.amount < 0) {
                item.expense = item.amount;
              } else {
                item.income = item.amount;
              }
              if (!item.div_description) {
                if (item.payer) {
                  item.div_description = item.payer;
                } else {
                  item.div_description = 'Zajednica stanara';
                }
              }
            }
            if (item.timestamp) {
              if (tableName == 'invoices') {
                item.dataType = 'invoice';
                item.timestamp = util.getFormattedDate(item.issue_date);
              } else {
                item.timestamp = util.getFormattedDate(item.timestamp);
              }
            }
          }
          context.commit('setTableData', {
            tableName,
            data
          });
          context.commit('setTableCount', {
            tableName,
            count: data.length
          });
        })
        .catch(() => {
          context.commit('setTableData', {
            tableName,
            data: []
          });
          context.commit('setTableCount', {
            tableName,
            count: 0
          });
        })
        .finally(() =>
          context.commit('setTableIsLoading', {
            tableName,
            isLoading: false
          })
        );
    },
    getAccountDetails(context) {
      let communityId = context.rootState.communities.activeCommunity.id;
      financesInstance
        .get(`communities/${communityId}/account`)
        .then(({ data }) => {
          let details = {};

          if (data.community.account) {
            details.account = data.community.account;
          } else {
            details.account = '/';
          }
          details.positive_balance = data.community.positive;
          details.negative_balance = data.community.negative;
          details.balance = data.community.balance;
          details.mb = data.community.mb;
          details.pib = data.community.pib;
          details.bank = data.community.bank;
          context.commit('setAccount', details);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  getters: {
    getLastFiveRowsForTable: state => tableName => {
      const tableData = state[tableName];
      const count = tableData.count;
      let result = [];

      let tableRows = count >= 5 ? 5 : count;
      for (let index = 0; index < tableRows; index++) {
        const row = tableData.data[index];
        result.push(row);
      }

      return result;
    },
    getTableDetails: state => tableName => {
      return {
        ...state[tableName]
      };
    }
  },
  namespaced: true
};
